import { Dropdown } from '@/components/Dropdown';
import { ArrowRight, ListItemIcon, ListItemText, MenuItem } from '@/components/Dropdown/MenuItems/components';
import Buildings from '@/images/Buildings.svg';
import Videos from '@/images/Videos.svg';
import { useAuth } from '@/services/auth';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function OrgVideosDropList() {
    const { user, isOrg } = useAuth();
    const [open, setOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const activeCreatedBy = useMemo(() => searchParams.get('created_by'), [searchParams]);

    const dropdownOptions = useMemo(
        () => [
            { key: 'myVideos', label: 'My videos', icon: Videos, value: user?.sub, testId: 'my-videos-menu-item' },
            { key: 'allOrgVideos', label: 'All organization videos', icon: Buildings, value: '', testId: 'all-org-videos-menu-item' },
        ],
        []
    );

    const selectedOption = useMemo(() => {
        return dropdownOptions.find(option => option.value === activeCreatedBy) ?? dropdownOptions[0];
    }, [activeCreatedBy]);

    useEffect(() => {
        if (!isOrg) return;
        setSearchParams(currentSearchParams => {
            currentSearchParams.set('created_by', selectedOption?.value ?? '');
            return currentSearchParams;
        });
    }, [selectedOption, isOrg]);

    const items = useMemo(
        () =>
            dropdownOptions.map(option => ({
                label: (
                    <MenuItem
                        key={option.key}
                        selected={option.value === selectedOption?.value}
                        data-testid={option.testId}
                        onClick={() => {
                            setSearchParams(currentSearchParams => {
                                currentSearchParams.set('created_by', option.value ?? '');
                                return currentSearchParams;
                            });
                            setOpen(false);
                        }}>
                        <ListItemIcon>
                            <img src={option.icon} height={24} />
                        </ListItemIcon>
                        <ListItemText>{option.label}</ListItemText>
                    </MenuItem>
                ),
            })),
        [activeCreatedBy, user?.sub]
    );

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleOpen = useCallback(() => {
        setOpen(true);
    }, []);

    if (!isOrg) {
        return null;
    }

    return (
        <Dropdown
            closed={!open}
            onClose={handleClose}
            onOpen={handleOpen}
            items={items}
            trigger={
                <MenuItem data-testid="org-videos-dropdown">
                    <ListItemIcon>
                        <img width={20} height={20} src={selectedOption?.icon} />
                    </ListItemIcon>
                    <ListItemText>{selectedOption?.label}</ListItemText>
                    <ArrowRight>{!open ? <ExpandLess /> : <ExpandMore />}</ArrowRight>
                </MenuItem>
            }
        />
    );
}
